/**
 * Navbar — top app bar. Shows nav links + logout when signed in;
 * shows Login/Sign up otherwise.
 */
import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { auth, AuthAPI } from '../services/api';

export default function Navbar() {
    const navigate = useNavigate();
    const user = auth.user();

    async function handleLogout() {
        try { await AuthAPI.logout(); } catch (_) { /* fine */ }
        auth.clear();
        navigate('/login', { replace: true });
    }

    const linkClass = ({ isActive }) =>
        `px-3 py-1.5 rounded text-sm font-medium ${
            isActive ? 'bg-brand-50 text-brand-700' : 'text-gray-600 hover:text-gray-900'
        }`;

    return (
        <header className="bg-white border-b border-gray-200">
            <div className="max-w-6xl mx-auto px-4 h-14 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2">
                    <span className="inline-block w-7 h-7 rounded bg-brand-500 text-white grid place-items-center font-bold text-sm">
                        L
                    </span>
                    <span className="font-semibold text-gray-900">Lead Scoring</span>
                </Link>

                {user ? (
                    <nav className="flex items-center gap-1">
                        <NavLink to="/"         className={linkClass} end>Dashboard</NavLink>
                        <NavLink to="/upload"   className={linkClass}>Upload</NavLink>
                        <NavLink to="/settings" className={linkClass}>Settings</NavLink>
                        <span className="mx-3 text-sm text-gray-500 hidden sm:inline">
                            {user.email}
                        </span>
                        <button
                            onClick={handleLogout}
                            className="px-3 py-1.5 rounded text-sm font-medium text-gray-700 hover:bg-gray-100"
                        >
                            Log out
                        </button>
                    </nav>
                ) : (
                    <nav className="flex items-center gap-2">
                        <Link to="/login"  className="px-3 py-1.5 text-sm text-gray-700">Log in</Link>
                        <Link to="/signup" className="px-3 py-1.5 rounded bg-brand-500 text-white text-sm font-medium hover:bg-brand-600">
                            Sign up
                        </Link>
                    </nav>
                )}
            </div>
        </header>
    );
}
